import { RevealText } from "src/components/animation/reveal-text"
import Button from "src/components/button"
import corporatePointData from "src/data/corporate-point-data.json"
function EnterpriseAndCorporate(){
    return(<div className="pt-[139px]">
        <div id="headline" className="relative flex flex-col justify-center items-center mx-[24px] sm:mx-[80px] md:mx-[120px] xl:mx-[240px] h-[480px] md:h-[496px] xl:h-full my-[0px] xl:my-[128px] gap-[16px]">
            <div className="text-[32px] lg:text-[48px] font-bold leading-[36px] lg:leading-[50px]">
                <RevealText><span className="font-lora font-medium italic">Sovereign Digital</span> Infrastructure<br/>
                for High-Throughput Enterprises.</RevealText>
            </div>
            <RevealText className="w-full lg:w-1/2 text-grey">Discover practical, high-throughput software ecosystems built for complex enterprises, fast-growing scale-ups, and grassroots digital safety movements.</RevealText>
            <div className="flex flex-row gap-[16px]">
                <Button to={"/contact-us"} onClick={() => {}} color="yellow">Contact Sales</Button>
            </div>
            <img className="absolute right-0 top-0 animate-float-enhanced-a" src="/icons/star-1.svg"></img>
            <img className="absolute left-0 bottom-0 animate-float-enhanced-b" src="/icons/star-2.svg"></img>
        </div>
        <hr/>
        <div className="my-[96px] flex flex-col px-[16px] justify-center items-center gap-[32px]">
            <div>
                <p className="text-[24px] lg:text-[32px] font-semibold "><span className="font-lora font-medium italic">Secure</span> and <span className="font-lora font-medium italic">Reliable</span> IT Solutions for Your Enterprise</p>
                <p className="text-grey">Rooted in our original vision for cyber security, we make protecting your corporate data our absolute top priority.</p>
            </div>
            <div className="flex flex-col md:flex-row text-left lg:text-center w-full xl:w-1/2 justify-top items-center gap-[16px] md:gap-[0px]">
                <div className="flex flex-col justify-top items-center gap-[16px] px-[32px]">
                    <img className="w-[65px]" src={"/icons/network-yellow.svg"}></img>
                    <p>Replacing restrictive SaaS dependencies with proprietary systems to build permanent corporate balance-sheet assets.</p>
                </div>
                <div className="flex flex-col justify-top items-center gap-[16px] px-[32px] md:border-x-[1px]">
                    <img className="w-[65px]" src={"/icons/clap-yellow.svg"}></img>
                    <p>Unifying fractured data endpoints into low-latency middleware engines that effortlessly handle massive traffic spikes.</p>
                </div>
                <div className="flex flex-col justify-top items-center gap-[16px] px-[32px]">
                    <img className="w-[65px]" src={"/icons/computer-yellow.svg"}></img>
                    <p>Embedding granular access controls and cryptographic tracing directly into the source code from day one.</p>
                </div>
            </div>
        </div>
        <div className="py-[96px] px-[48px] mx-[24px] flex flex-col lg:flex-row gap-[48px] bg-black text-white rounded-[16px] justify-start lg:justify-between items-center text-left">
            <p className="text-[24px] lg:text-[32px] font-semibold ">Engineered to Clear <br/> the Strictest <span className="font-lora font-medium italic">Security Reviews</span></p>
            <grid className="grid grid-cols-1 lg:grid-cols-2 text-left gap-y-[32px]">
                {corporatePointData.map(x => {
                    return(<div>
                        ✓ {x}
                    </div>)     
                })}
            </grid>
        </div>
        <div className="my-[96px] flex flex-col gap-[18px] justify-center items-center">
            <div>
                <p className="text-[24px] lg:text-[32px] font-semibold "><span className="font-lora font-medium italic">Deploy</span> Harmony to your enterprise two ways</p>
                <p className="text-grey">Scale instantly via a dedicated managed ecosystem or establish total codebase sovereignty <br/>by deploying directly to your private infrastructure.</p>
            </div>
            <div className="grid grid-cols-1 text-left xl:w-1/3 py-[24px] mx-[18px]">
                <hr></hr>
                <div className="w-full flex flex-col md:flex-row gap-[8px] py-[16px]">
                    <div className="md:w-1/12">
                        <img className="" src="/icons/leaves-yellow.svg"></img>
                    </div>
                    <p className="md:w-6/12">Fully Managed Cloud Architecture</p>
                    <p className="md:w-5/12">Scale instantly with a dedicated, zero-maintenance cloud environment optimized for high concurrency.</p>
                </div>
                <hr></hr>
                <div className="w-full flex flex-col md:flex-row gap-[8px] py-[16px]">
                    <div className="md:w-1/12">
                        <img className="w=fit" src="/icons/leaves-yellow.svg"></img>
                    </div>
                    <p className="md:w-6/12">Sovereign Self-Hosted Deployment</p>
                    <p className="md:w-5/12">Maintain 100% data isolation and codebase sovereignty by hosting directly on your own infrastructure.</p>
                </div>
                <hr></hr>
            </div>
        </div>
        <hr/>
        <div className="px-[16px] md:px-[0px] relative py-[128px] flex flex-col gap-[24px] justify-center items-center text-center">
            <h1 className="text-[32px] lg:text-[48px] font-bold leading-[36px] lg:leading-[50px]">Ready to bring <span className="font-lora font-medium italic">Harmony</span><br/>to your organization?</h1>
            <Button to={"/contact-us"} onClick={() => {}} color={"black"}>Contact Sales</Button>
            <img className="absolute right-4 md:right-16 top-10 w-8 md:w-auto animate-float-enhanced-a opacity-50 md:opacity-100" src="/icons/star-1.svg" alt="" />
            <img className="absolute left-4 md:left-16 bottom-10 md:bottom-auto md:top-20 w-6 md:w-auto animate-float-enhanced-b opacity-50 md:opacity-100" src="/icons/star-2.svg" alt="" />
        </div>
    </div>)
}

export default EnterpriseAndCorporate